import { useEffect } from 'react';

import { useConfirmDialogContext } from '../contexts/ConfirmDialog';
import { Colors } from '../constants';
import { hasAppliedThemeClass } from '../components/shared/Topbar/helpers/header.helper';

export function useDailyVersionCheck() {
  const { showConfirmationDialog } = useConfirmDialogContext();

  useEffect(() => {
    const now = new Date().toISOString().slice(0, 10); // "2025-06-17"
    const lastChecked = localStorage.getItem('last_version_check');
    const currentVersion = localStorage.getItem('app_version');

    if (lastChecked === now) return;

    fetch(`/meta.json?_=${Date.now()}`)
      .then(res => res.json())
      .then(({ version }) => {
        localStorage.setItem('last_version_check', now);

        if (currentVersion && currentVersion !== version) {
          showConfirmationDialog({
            message: (
              <div className="flex align- items-start gap-2">
                <i
                  className="pi pi-exclamation-circle"
                  style={{
                    color: Colors.PF_BLUE,
                    fontSize: '1rem',
                    marginTop: '0.2rem', // Align icon with first line
                  }}
                ></i>
                <div>
                  <p style={{ margin: 0 }}>
                    An updated version of the application is available.
                  </p>
                  <p style={{ margin: 0 }}>
                    Please refresh to continue with the latest features.
                  </p>
                </div>
              </div>
            ),
            position: 'top',
            header: 'Confirmation',
            acceptLabel: 'Reload Now',
            rejectLabel: 'Later',
            acceptClassName: `p-button-primary p-button-sm ${!hasAppliedThemeClass() && 'default-blue-bg default-blue-border'}`,
            acceptIcon: 'pi pi-refresh',
            accept: () => {
              localStorage.setItem('app_version', version);
              window.location.reload();
            },
            reject: () => {},
            pt: {
              header: {
                className: 'border-bottom-1 border-400',
                style: {
                  backgroundColor: '#eff6ff',
                  padding: '1.1rem 1rem',
                },
              },
              content: {
                style: {
                  paddingTop: '1.5rem',
                  paddingLeft: '0.75rem',
                  paddingBottom: '1.5rem',
                  paddingRight: '1.5rem',
                },
              },
              footer: {
                className: 'border-top-1 border-400',
                style: {
                  padding: '0.75rem 0.75rem',
                  display: 'flex',
                  justifyContent: 'flex-end',
                },
              },
            },
          });
        } else {
          localStorage.setItem('app_version', version);
        }
      })
      .catch(err => {
        console.warn('Version check failed:', err);
      });
  }, []);
}
